import { fork, takeEvery } from 'redux-saga/effects';
import { AdminTranslationsApi } from 'api';
import { sagasHandlersFactory } from 'store/entities/utils';
import * as actions from './actions';
import { ResponseError } from '../../../api/types';

const handleGetAdminSessionsTranslationsRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getAdminSessionsTranslations,
  request: AdminTranslationsApi.getAdminSessionsTranslations,
  requestArgsBuilder: (action) => action.payload.params.eventId,
  notifyError: (error) => (error as ResponseError).response?.status !== 404,
  transformResponse: (response) => response.results,
});

const handleUpdateAdminSessionTranslationRequest = sagasHandlersFactory.createRuntimeUpdateHandler({
  actions: actions.updateAdminSessionTranslation,
  request: AdminTranslationsApi.updateAdminSessionTranslation,
  requestArgsBuilder: (action) => {
    const { id, params, entity } = action.payload;
    const { eventId } = params;
    return [eventId, id, { body: entity }];
  },
});

export default function* adminDonationTranslationsSagas() {
  yield takeEvery(actions.getAdminSessionsTranslations.request.type, handleGetAdminSessionsTranslationsRequest);
  yield fork(handleUpdateAdminSessionTranslationRequest);
}
